export function getAirQualityStatus(gridCode: number) {
  switch (gridCode) {
    case 1:
      return "Good";
    case 2:
      return "Moderate";
    case 3:
      return "Unhealthy for Sensitive Groups";
    case 4:
      return "Unhealthy";
    case 5:
      return "Very Unhealthy";
    case 6:
      return "Hazardous";
    default:
      return "";
  }
}

export function getAirQualityDescription(gridcode: number) {
  switch (gridcode) {
    case 1:
      return "AQI of 0 to 50";
    case 2:
      return "AQI of 51 to 100";
    case 3:
      return "AQI of 101 to 150";
    case 4:
      return "AQI of 151 to 200";
    case 5:
      return "AQI of 201 to 300";
    case 6:
      return "AQI of 301 to 500";
    default:
      return "";
  }
}
export const aqiBasics = {
  head: [
    "Daily AQI Color",
    "Levels of Concern",
    "Values of Index",
    "Description of Air Quality",
  ],
  rows: [
    {
      color: "rgb(0, 228, 0)",
      "Daily AQI Color": "Green",
      "Levels of Concern": "Good",
      "Values of Index": "0 to 50",
      "Description of Air Quality":
        "Air quality is satisfactory, and air pollution poses little or no risk.",
    },
    {
      color: "#eab308",
      "Daily AQI Color": "Yellow",
      "Levels of Concern": "Moderate",
      "Values of Index": "51 to 100",
      "Description of Air Quality":
        "Air quality is acceptable. However, there may be a risk for some people, particularly those who are unusually sensitive to air pollution.",
    },
    {
      color: "rgb(255, 126, 0)",
      "Daily AQI Color": "Orange",
      "Levels of Concern": "Unhealthy for Sensitive Groups",
      "Values of Index": "101 to 150",
      "Description of Air Quality":
        "Members of sensitive groups may experience health effects. The general public is less likely to be affected.",
    },
    {
      color: "rgb(126, 0, 35)",
      "Daily AQI Color": "Red",
      "Levels of Concern": "Unhealthy",
      "Values of Index": "151 to 200",
      "Description of Air Quality":
        "Some members of the general public may experience health effects; members of sensitive groups may experience more serious health effects.",
    },
    {
      color: "rgb(143, 63, 151)",
      "Daily AQI Color": "Purple",
      "Levels of Concern": "Very Unhealthy",
      "Values of Index": "201 to 300",
      "Description of Air Quality":
        "Health alert: The risk of health effects is increased for everyone.",
    },
    {
      color: "rgb(126, 0, 35)",
      "Daily AQI Color": "Maroon",
      "Levels of Concern": "Hazardous",
      "Values of Index": "301 and higher",
      "Description of Air Quality":
        "Health warning of emergency conditions: everyone is more likely to be affected.",
    },
  ],
};
